import styled from "styled-components";
import { GrayGradientDiv } from "../../styled";

export const Container = styled(GrayGradientDiv)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 45px;
`;

export const Text = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.darkGray};
    text-align: center;
    line-height: 20px;
    
    span:first-child {
        font-weight: ${({ theme }) => theme.fontWeights.bold};
    }
    span:nth-child(2) {
        font-weight: ${({ theme }) => theme.fontWeights.medium};
    }
`;
